<template>
    <div class="CopyrightBar">
        <span class="bottom-logo"></span>
        <span class="bottom-text">Copyright © 2023 PCI Technology Group Co.,Ltd.All Rights Reserved 2022 ©佳都科技集团股份有限公司版权所有</span>
    </div>
</template>
<script>
export default {
    name: 'CopyrightBar'
};
</script>
<style  lang="scss" scoped>
.CopyrightBar {
    font-size: 12px;
    margin: 5px;
    text-align: center;
    .bottom-logo {
        display: inline-block;
        width: 52px;
        height: 13px;
        background: url(../../../theme/images/logo-bottom.svg) no-repeat center;
        background-size: contain;
        vertical-align: middle;
    }
    .bottom-text {
        opacity: 0.25;
        margin-left: 1em;
    }
}
</style>
